import React from "react";

export type FormattedNumberProps = {
  value: string | number
  className?: string
  suffix?: string
};

export const FormattedNumber: React.FC<FormattedNumberProps> = ({ value, className = "", suffix = "" }) => {
  const numberValue = typeof value === "string" ? parseFloat(value.replace(/\s/g, "").replace(",", ".")) : value;

  const formatted = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(numberValue)
    .replace(/\u202F/g, " ");

  return (
    <span className={className}>
      {formatted}
      {suffix}
    </span>
  );
};
